import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Spinner } from "reactstrap";

import { ThemeRenderer } from "./ThemeProvider/ThemeHandler";
import ThemeFooter from "./component/ThemeFooter";
import ItemService from "../../services/OrderingServices/ItemService";
import Error500 from "../../pages/AuthenticationInner/Errors/Error500";
import DeviceNotRegistered from "../../pages/AuthenticationInner/Errors/DeviceNotRegistered";
import OrganizationService from "../../services/OrderingServices/OrganizationService";
import AdService from "../../services/AdService/AdService";
import AdLogService from "../../services/AdService/AdLogService";
import { initLocalStorageCleanup } from "../../utils/localStorageCleanup";

import { Triangle } from "react-loader-spinner";
import or from "../../assets/ads/or.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, FreeMode, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import {
  formatDateTime,
  formatDateTimeWithSeconds,
} from "../../Components/Common/FormatDate";

const OrgPage = () => {
  const [apiResponse, setApiResponse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [orgDetail, setOrgDetail] = useState();
  const [ads, setAds] = useState([]);
  const [deviceInfo, setDeviceInfo] = useState(null);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false); // 🎥 Video state
  console.log("🚀 ~ OrgPage ~ deviceInfo:", deviceInfo);

  // Track logged ads to prevent duplicate logging
  // const loggedAdsRef = useRef(new Set());
  const lastLoggedIndexRef = useRef(null);

  // Track if ads have been fetched to prevent double fetching
  const adsFetchedRef = useRef(false);

  // Swiper ref and slide timer
  const swiperRef = useRef(null);
  const slideTimerRef = useRef(null);
  // const { orgcode } = useParams();

  const { orgcode: paramOrgCode } = useParams();
  // const orgcode = "DEM105";
  const appType = window.APP_CONFIG.appType;

  // const orgcode =
  //   appType === "TouchBased" ? window.APP_CONFIG.orgcode : paramOrgCode;

  const isTouchBased = appType === "TouchBased";
  const orgcode =
    appType === "TouchBased" ? localStorage.getItem("orgcode") : paramOrgCode;
  console.log("🚀 ~ OrgPage ~ orgcode:", orgcode);

  const [isTouchBasedSetting, setIsTouchBasedSetting] = useState(() => {
    const stored = localStorage.getItem("isTouchBasedSetting");
    return stored !== null ? JSON.parse(stored) : true;
  });
  // --------------------------------------------------------------------------------------------------------------------------------------------
  // localStorage.setItem("orgcode", orgcode);

  // ----------------isPublicOrder----------------------
  const isPublicOrder = true;

  const navigate = useNavigate();

  // Initialize localStorage cleanup mechanism on mount
  useEffect(() => {
    // Initialize cleanup mechanism to clear localStorage after 10 min of app being closed
    initLocalStorageCleanup();

    return () => {
      // Cleanup timer on component unmount
      if (slideTimerRef.current) {
        clearTimeout(slideTimerRef.current);
      }
    };
  }, []);

  // Get device info from localStorage (set by modalinspect.jsx)
  useEffect(() => {
    try {
      const deviceContext = localStorage.getItem("deviceContext");
      const macId = localStorage.getItem("macId");
      const ipAddress = localStorage.getItem("ipAddress") || "0.0.0.0";

      if (deviceContext) {
        const context = JSON.parse(deviceContext);
        setDeviceInfo({
          macId: macId,
          deviceName: context.deviceName || "Unknown Device",
          ipAddress: ipAddress,
          deviceCode: context.deviceCode,
          orgCode: context.orgCode,
          terminal: context.terminal || "T1",
        });
      }
    } catch (error) {
      console.error("Error reading device info:", error);
    }
  }, []);

  // Log ad impression when banner is displayed
  // const logAdImpression = async (ad, visibleSeconds) => {
  //   if (!deviceInfo) return; // Skip if no device info

  //   // Use durationSeconds from ad if not provided
  //   const displayDuration = visibleSeconds || ad.durationSeconds || 5;

  //   // Prevent logging the same ad twice
  //   // if (loggedAdsRef.current.has(ad.id)) {
  //   //   console.log("⏭️ ~ Ad already logged, skipping:", ad.id);
  //   //   return;
  //   // }

  //   try {
  //     // Get current device time
  //     // loggedAdsRef.current.add(ad.id); // Mark as logged

  //     const now = new Date();
  //     const shownTime = now.toISOString();
  //     console.log("🚀 ~ logAdImpression ~ shownTime:", shownTime);

  //     console.log(
  //       "🚀 ~ logAdImpression ~ shownTime12:",
  //       formatDateTimeWithSeconds(shownTime),
  //     );
  //     const hiddenTime = new Date(
  //       now.getTime() + displayDuration * 1000,
  //     ).toISOString();

  //     const adLog = {
  //       adId: ad.id,
  //       macId: deviceInfo.macId,
  //       deviceName: deviceInfo.deviceName,
  //       ipAddress: deviceInfo.ipAddress,
  //       shownAt: shownTime,
  //       hiddenAt: hiddenTime,
  //       visibleSeconds: displayDuration,
  //       playedSeconds: displayDuration,
  //       wasCompleted: true,
  //       wasSkipped: false,
  //       displayReason: 1, // Banner display
  //       screenName: "Banner",
  //       appVersion: "v1",
  //     };
  //     console.log("🚀 ~ logAdImpression ~ Current Device Time:", now);
  //     console.log("🚀 ~ logAdImpression ~ adLog:", adLog);

  //     await AdLogService.logAdImpression(adLog);

  //     console.log("✅ Ad impression logged:", ad.id);
  //   } catch (error) {
  //     console.error("❌ Error logging ad impression:", error);
  //     // Remove from logged set if error occurs
  //     // loggedAdsRef.current.delete(ad.id);
  //   }
  // };

  useEffect(() => {
    // Skip if orgcode is invalid (will show DeviceNotRegistered page)
    if (!orgcode) {
      return;
    }

    const fetchOrgDetail = async () => {
      try {
        const response = await OrganizationService.detailByCode(orgcode);
        console.log("🚀 ~ fetchOrgDetail ~ response:", response);
        setOrgDetail(response);

        // Dynamic document title
        document.title = response?.organization?.name || "Organization Page";
      } catch (err) {
        console.error("Error fetching organization data:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrgDetail();
  }, [orgcode, navigate]);

  // Fetch ads on component mount and set up polling for smooth updates
  useEffect(() => {
    // Skip if already fetched or no device info (prevents double fetch in StrictMode)
    if (adsFetchedRef.current || !deviceInfo) {
      if (!deviceInfo) {
        console.log("⏭️ ~ Device info not available yet, skipping ad fetch");
      } else {
        console.log("⏭️ ~ Ads already fetched, skipping");
      }
      return;
    }

    const fetchAds = async () => {
      try {
        // Fetch ads by MAC address using the new API
        const data = await AdLogService.getAdsByMacAddress(deviceInfo.macId);
        console.log("🚀 ~ fetchAds ~ data:", data);

        // Keep all ad types and let consumers decide how to render each type
        const baseApi =
          window.APP_CONFIG?.api4?.baseapi ||
          "https://api-databasewebservice.danfesolution.com";
        const resolveMediaUrl = (path) => {
          if (!path) return "";
          if (/^https?:\/\//i.test(path)) return path;
          if (path.startsWith("/")) return `${baseApi}${path}`;
          return `${baseApi}/${path}`;
        };
        const normalizedAds = (Array.isArray(data) ? data : [])
          .sort((a, b) => a.priority - b.priority)
          .map((ad) => ({
            id: ad.id,
            title: ad.title,
            description: ad.description,
            mediaType: Number(ad.mediaTypeValue) || 0, // ← use mediaTypeValue
            adFormat: Number(ad.adFormatValue) || 0, // ← use adFormatValue

            mediaPath: resolveMediaUrl(ad.mediaPath),
            thumbnailPath: resolveMediaUrl(ad.thumbnailPath),
            priority: ad.priority ?? 999,
            durationSeconds: ad.durationSeconds ?? ad.videoLengthSeconds ?? 10,
            videoLengthSeconds: ad.videoLengthSeconds || 0,
          }));

        console.log("🚀 ~ fetchAds ~ normalizedAds:", normalizedAds);
        setAds(normalizedAds);
        // loggedAdsRef.current.clear(); // Clear logged ads when new ads are fetched
      } catch (error) {
        console.error("Error fetching ads by MAC address:", error);
      }
    };

    // Fetch ads immediately on component mount
    adsFetchedRef.current = true;
    fetchAds();

    // Set up polling to refresh ads every 30 seconds for smooth updates
    const adRefreshInterval = setInterval(fetchAds, 30000);

    // Cleanup interval on component unmount
    return () => clearInterval(adRefreshInterval);
  }, [deviceInfo]);

  useEffect(() => {
    // Skip if orgcode is invalid (will show DeviceNotRegistered page)
    if (!orgcode) {
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      try {
        const response = await ItemService.itemTheme(orgcode);
        setApiResponse(response);

        // Dynamic document title
        document.title = response?.organization?.name || "Organization Page";
      } catch (err) {
        console.error("Error fetching organization data:", err);
        setError(err);
        // Only navigate away for non-TouchBased or if we have orgcode
        if (!isTouchBased) {
          navigate("/");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [orgcode, navigate, isTouchBased]);

  // Compute imageAds before all hooks
  const imageAds = ads.filter((ad) => Number(ad.mediaType) === 1);

  // ============= EARLY RETURN: Missing orgcode in TouchBased mode =============
  if (isTouchBased && !orgcode) {
    return <DeviceNotRegistered />;
  }

  // SLIDESHOW EFFECT - MUST BE CALLED BEFORE CONDITIONAL RETURNS
  // useEffect(() => {
  //   if (!deviceInfo || imageAds.length === 0) {
  //     // Clear timer if no ads or device info
  //     if (slideTimerRef.current) {
  //       clearTimeout(slideTimerRef.current);
  //     }
  //     return;
  //   }

  //   // 🚨 STOP slideshow when video is playing
  //   if (isVideoPlaying) {
  //     if (slideTimerRef.current) {
  //       clearTimeout(slideTimerRef.current);
  //     }
  //     return;
  //   }

  //   // Clear previous timer
  //   if (slideTimerRef.current) {
  //     clearTimeout(slideTimerRef.current);
  //   }

  //   // ----------- CASE 1: Only One Ad -----------
  //   if (imageAds.length === 1) {
  //     const singleAd = imageAds[0];
  //     const duration = singleAd.durationSeconds || 5;

  //     const runSingleAdLoop = () => {
  //       // 🛑 Extra safety: check again before logging
  //       if (isVideoPlaying) return;

  //       logAdImpression(singleAd, duration);

  //       slideTimerRef.current = setTimeout(() => {
  //         runSingleAdLoop(); // loop again
  //       }, duration * 1000);
  //     };

  //     runSingleAdLoop();
  //     return;
  //   }

  //   // ----------- CASE 2: Multiple Ads -----------
  //   if (swiperRef.current) {
  //     swiperRef.current?.swiper?.slideToLoop(0); // reset to first slide
  //   }

  //   const startSlideShow = (index = 0) => {
  //     // 🛑 Extra safety: check again before logging
  //     if (isVideoPlaying) return;

  //     const currentAd = imageAds[index];
  //     if (!currentAd) return;

  //     const duration = currentAd.durationSeconds || 5;

  //     logAdImpression(currentAd, duration);

  //     slideTimerRef.current = setTimeout(() => {
  //       if (!swiperRef.current?.swiper) return;

  //       swiperRef.current.swiper.slideNext();

  //       const nextIndex = (index + 1) % imageAds.length;

  //       startSlideShow(nextIndex);
  //     }, duration * 1000);
  //   };

  //   startSlideShow(0);

  //   return () => {
  //     if (slideTimerRef.current) {
  //       clearTimeout(slideTimerRef.current);
  //     }
  //   };
  // }, [imageAds, deviceInfo, isVideoPlaying]); // 🎥 Added isVideoPlaying to deps

  return (
    <div>
      {loading && (
        <div
          className="d-flex flex-column justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <Triangle
            visible={true}
            height="80"
            width="80"
            color="#5B71B9"
            ariaLabel="triangle-loading"
          />
          <h5 className="mt-3">Loading...</h5>
        </div>
      )}

      {error && <Error500 />}

      {!loading && !error && (
        <>
          {apiResponse &&
            (isPublicOrder ? (
              <ThemeRenderer
                themeKey="Theme2"
                orgInfo={apiResponse}
                orgData={orgDetail}
                orgcode={orgcode}
                ads={ads}
                isVideoPlaying={isVideoPlaying}
                setIsVideoPlaying={setIsVideoPlaying}
              />
            ) : (
              <ThemeRenderer
                themeKey="Theme1"
                orgInfo={apiResponse}
                orgData={orgDetail}
                orgcode={orgcode}
                ads={ads}
                isVideoPlaying={isVideoPlaying}
                setIsVideoPlaying={setIsVideoPlaying}
              />
            ))}
        </>
      )}
    </div>
  );
};
``;

export default OrgPage;
